module.exports = __webpack_public_path__ + "static/img/180153_9.706a552.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/180153_9.jpg
// module id = yWNj
// module chunks = 1